import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Lock, ArrowRight } from 'lucide-react';
import { changePasswordApi } from '../api/auth';
import DashboardLayout from '../layouts/DashboardLayout';
import '../styles/auth.scss';

function ChangePassword() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const onChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
    setErrors(prev => ({ ...prev, [key]: '' }));
  };

  const validate = () => {
    const errs = {};
    if (!form.oldPassword) errs.oldPassword = '请输入原密码';
    if (!form.newPassword) errs.newPassword = '请输入新密码';
    else if (form.newPassword.length < 6) errs.newPassword = '密码至少6位';
    if (!form.confirmPassword) errs.confirmPassword = '请确认新密码';
    else if (form.newPassword !== form.confirmPassword) errs.confirmPassword = '两次密码不一致';
    if (form.oldPassword && form.newPassword && form.oldPassword === form.newPassword) {
      errs.newPassword = '新密码不能与原密码相同';
    }
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    try {
      await changePasswordApi({
        oldPassword: form.oldPassword,
        newPassword: form.newPassword
      });
      // TODO: 修改成功提示并跳转
      navigate('/');
    } catch (err) {
      setErrors({ oldPassword: err.message || '修改失败' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <div className="auth-page auth-page--inner">
        <span className="auth-badge">SECURE AUTHENTICATION</span>
        <h1 className="auth-title">修改密码</h1>
        <p className="auth-desc">使用原密码验证身份后设置新密码。</p>

        <form className="auth-card" onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-field-label">原密码 (CURRENT PASSWORD)</label>
            <div className="auth-field-input-wrap">
              <Lock size={18} className="field-icon" />
              <input
                type="password"
                placeholder="请输入原密码"
                value={form.oldPassword}
                onChange={e => onChange('oldPassword', e.target.value)}
              />
            </div>
            {errors.oldPassword && <div className="auth-field-error">{errors.oldPassword}</div>}
          </div>

          <div className="auth-field">
            <label className="auth-field-label">新密码 (NEW PASSWORD)</label>
            <div className="auth-field-input-wrap">
              <Lock size={18} className="field-icon" />
              <input
                type="password"
                placeholder="请输入新密码（至少6位）"
                value={form.newPassword}
                onChange={e => onChange('newPassword', e.target.value)}
              />
            </div>
            {errors.newPassword && <div className="auth-field-error">{errors.newPassword}</div>}
          </div>

          <div className="auth-field">
            <label className="auth-field-label">确认新密码 (CONFIRM PASSWORD)</label>
            <div className="auth-field-input-wrap">
              <Lock size={18} className="field-icon" />
              <input
                type="password"
                placeholder="请再次输入新密码"
                value={form.confirmPassword}
                onChange={e => onChange('confirmPassword', e.target.value)}
              />
            </div>
            {errors.confirmPassword && <div className="auth-field-error">{errors.confirmPassword}</div>}
          </div>

          <button className="auth-submit" type="submit" disabled={loading}>
            {loading ? '提交中...' : '修改密码'} <ArrowRight size={18} />
          </button>

          <Link className="auth-link" to="/forgot-password">忘记密码？</Link>
        </form>
      </div>
    </DashboardLayout>
  );
}

export default ChangePassword;
